import { render, staticRenderFns } from "./EditToken.vue?vue&type=template&id=8e623d66&"
import script from "./EditToken.vue?vue&type=script&lang=js&"
export * from "./EditToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports